import { deleteRequest } from '..';

const archiveChatbotSession = async (sessionId: string) => {
  const requestUrl = `chatbot-api/chat-sessions/${sessionId}?hardDelete=false`;
  await deleteRequest(requestUrl);
};

export default archiveChatbotSession;
